export const isProduction = window.location.host.includes('.cloud.');
/** 判断是否在iframe中 */
export const isInFrame = window.top !== self;
/** 判断是否在iframe中检查权限
 * @inner
 */
export const shouldCheck = () => isInFrame ? config.checkFrame : true;
export const config = {
    checkFrame: true,
    defaultAccess: {
        wechatLimit: 'userinfo',
        notWechatLimit: 'nothing',
    },
    formOpen: `https://form.${isProduction ? 'cloud' : 'beta'}.custouch.com/open/v1/form`,
    appId: '',
    uaId: '',
    logo: '',
    errorSession: null,
    accessType: 'site',
    onMemberError: null,
    actionPrefix: document.title,
    trackOriginOpenId: true,
    debug: false,
    proxyRequest: null,
    SsoLink: ''
};
/**
 * 用于设置基础配置
 * @export
 * @param {BaseConfig} options
 * @return {*}  {BaseConfig}
 */
export function setConfig(options) {
    return Object.assign(config, options);
}
